import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import ProfileSetup from './pages/ProfileSetup';
import Dashboard from './pages/Dashboard';
import GuardianDashboard from './pages/GuardianDashboard';
import MatchView from './pages/MatchView';
import GuardianMode from './pages/GuardianMode';
export function App() {
  return <Router data-id="element-0">
      <div className="min-h-screen bg-gradient-to-b from-amber-50 to-amber-100" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<LandingPage data-id="element-4" />} data-id="element-3" />
          <Route path="/login" element={<Login data-id="element-6" />} data-id="element-5" />
          <Route path="/profile-setup" element={<ProfileSetup data-id="element-8" />} data-id="element-7" />
          <Route path="/dashboard" element={<Dashboard data-id="element-10" />} data-id="element-9" />
          <Route path="/guardian-dashboard" element={<GuardianDashboard data-id="element-12" />} data-id="element-11" />
          <Route path="/match" element={<MatchView data-id="element-14" />} data-id="element-13" />
          <Route path="/guardian" element={<GuardianMode data-id="element-16" />} data-id="element-15" />
        </Routes>
      </div>
    </Router>;
}